/* MusclesRise homepage — scroll reveal + count-up stats.
   Deliberately dependency-free and fail-safe: if anything throws, the CSS
   fallbacks leave every element visible and readable. */
(function () {
  'use strict';

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Scroll reveal ---------- */

  function initReveal(root) {
    var targets = (root || document).querySelectorAll('.mr-reveal:not(.is-in)');
    if (!targets.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      for (var i = 0; i < targets.length; i++) targets[i].classList.add('is-in');
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          // Stagger siblings so a grid cascades instead of popping at once.
          var delay = parseInt(el.getAttribute('data-mr-delay') || '0', 10);
          setTimeout(function () {
            el.classList.add('is-in');
          }, delay);
          io.unobserve(el);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    for (var j = 0; j < targets.length; j++) io.observe(targets[j]);
  }

  /* ---------- Count-up stats ---------- */

  function countUp(el) {
    var raw = el.getAttribute('data-mr-count');
    var target = parseFloat(raw);
    if (isNaN(target)) return;

    var prefix = el.getAttribute('data-mr-prefix') || '';
    var suffix = el.getAttribute('data-mr-suffix') || '';
    // Preserve decimals exactly as authored (4.9 must not render as 5).
    var decimals = (raw.split('.')[1] || '').length;

    if (reduceMotion) {
      el.textContent = prefix + target.toFixed(decimals) + suffix;
      return;
    }

    var duration = 1600;
    var start = null;

    function frame(ts) {
      if (start === null) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      // easeOutExpo
      var eased = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
      el.textContent = prefix + (target * eased).toFixed(decimals) + suffix;
      if (progress < 1) requestAnimationFrame(frame);
    }

    requestAnimationFrame(frame);
  }

  function initStats(root) {
    var nums = (root || document).querySelectorAll('[data-mr-count]:not([data-mr-done])');
    if (!nums.length) return;

    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < nums.length; i++) {
        nums[i].setAttribute('data-mr-done', '');
        countUp(nums[i]);
      }
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.setAttribute('data-mr-done', '');
          countUp(entry.target);
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.4 }
    );

    for (var j = 0; j < nums.length; j++) io.observe(nums[j]);
  }

  /* ---------- Marquee ---------- */

  /* The track holds two identical groups and scrolls -50%, so the loop is
     seamless. Speed is derived from width to keep px/sec constant whether the
     strip has 3 items or 12. */
  function initMarquee(root) {
    var tracks = (root || document).querySelectorAll('.mr-marquee__track');
    for (var i = 0; i < tracks.length; i++) {
      var track = tracks[i];
      var group = track.querySelector('.mr-marquee__group');
      if (!group) continue;
      var pxPerSecond = parseFloat(track.getAttribute('data-mr-speed')) || 60;
      var seconds = group.offsetWidth / pxPerSecond;
      if (seconds > 0) track.style.setProperty('--mr-marquee-speed', seconds.toFixed(2) + 's');
    }
  }

  function initAll(root) {
    initReveal(root);
    initStats(root);
    initMarquee(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Re-run when a section is re-rendered in the theme customizer.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  window.addEventListener('resize', function () {
    initMarquee(document);
  });
})();
